module.exports = __webpack_public_path__ + "img/afPE.2ad063d0.png";